import React from "react";
import "./Loader.scss";
const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="orbit-spinner">
        <div className="orbit-dot" />
        <div className="orbit-dot" />
        <div className="orbit-dot" />
      </div>
      <p>Loading...</p>
    </div>
  );
};

export default Loader;
